let baseUrl = "";
if (process.env.NODE_ENV === 'development') {
	// 开发环境
	baseUrl = "https://www.xingjianji.com";
} else if (process.env.NODE_ENV === 'production') {
	// 生产环境
	// baseUrl = "http://tiktok2.xingkuajing.com";
	baseUrl = getBaseUrl();
}

function getBaseUrl(){
	var BASE_URL = '';
	var url = location.href;
	var arr = url.split('/'); //图片域名
	if(arr[2]) {
		BASE_URL = arr[0]+'//'+arr[2];
	}
	return BASE_URL
}

const courtConfig = {
	//微信公众号APPID
	publicAppId: "",
	//请求接口
	baseUrl: baseUrl,
	//平台名称
	platformName: "星剪辑",
	projectToken: "",
	//项目logo
	logoUrl: "",
};
//手机号验证正则表达式
const phoneRegular = /^1\d{10}$/;
//邮箱验证正则表达式
const mailRegular = /^\w+@\w+(\.[a-zA-Z]{2,3}){1,2}$/;
//密码验证正则表达式
const passwordRegular = /^[a-zA-Z0-9]{4,10}$/;
export default Object.assign({
	phoneRegular,
	mailRegular,
	passwordRegular
}, courtConfig);
